import { render, staticRenderFns } from "./UrlControl.vue?vue&type=template&id=f856fede&scoped=true&"
import script from "./UrlControl.vue?vue&type=script&lang=js&"
export * from "./UrlControl.vue?vue&type=script&lang=js&"
import style0 from "./UrlControl.vue?vue&type=style&index=0&id=f856fede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f856fede",
  null
  
)

export default component.exports